const Colors = {
    PRIMARY: '#4239B0',
    SECONDARY: '#1A0D55',
    WHITE: '#FFF',
    WHITE_50: 'rgba(255,255,255,0.5)',

    // New Colors
    ERROR_LIGHT_RED: '#FCEEEE',
    ERROR_RED: '#E45858',
    YELLOW: '#F2D74A',
    LIGHT_YELLOW: '#FEF9ED',
    GREY: '#C0C0C0',
    GREY_OXFORD: '#374957',
    GREY_WHITE: '#FFFFFF',
    NEUTRAL_BLACK: '#0C0D18', // body text,
    NEUTRAL_PLACEHOLDER: '#706D85', // placeholder
    NEUTRAL_DARK_GRAY: '#7C798B', // body text
    NEUTRAL_GRAY: '#CBCBCB', // border, hr, placeholder text disabled
    NEUTRAL_LIGHT_GRAY: '#F9F9F9', // background, background disabled input
    NEUTRAL_WHITE: '#FFFFFF',
    PRIMARY_PURPLE: '#4239B0',
    PRIMARY_PURPLE_10: '#F7F6FF',
    PRIMARY_PURPLE_30: '#F2F1FF',
    PRIMARY_PURPLE_50: '#B3B0D4',
    PREMIUM: '#BDAE40',
    PRIMARY_PURPLE_60: '#DCB8FF',
    PRIMARY_PURPLE_70: '#A19CD8',
    SECONDARY_RED: '#D34059',
    SECONDARY_RED_10: '#FBECEE',
    SECONDARY_RED_50: '#E9A0AC',
    SUCCESS_GREEN: '#8DD690',
    SUCCESS_LIGHT_GREEN: '#F4FBF4',
    WARNING_LIGHT_ORANGE: '#FEF5ED',
    WARNING_ORANGE: '#F2994A',
    DARK_GREEN: '#11452F',
    DASHBOARD: '#222426',
    DISABLE_FORM_BLACK: "#282c30",
    OTHERS_FREE: "#bb6bd9",
    OTHERS_GOLD: "#bdae40",
    OTHERS_BLUE: "#2f80ed",
    FLOATING_BAR_TEXT: "#242333",
    FLOATING_BAR_BUTTON_BACKGROUND: "#F2F1FF",
    DROPDOWN_FLOATING_TEXT: "#939393",
};

export default Colors;
